import { useLayoutEffect } from 'react'
import { parseAuthHash } from '../../../routes'
import { withRouter } from '../with-router'

const callBack = (props) => {
  useLayoutEffect(() => {
    const { location, params, navigate } = props
    parseAuthHash(location, params, navigate)
  }, [])

  return null
}
export default withRouter(callBack)
